import { type AnyAction, type Dispatch, type Middleware, type MiddlewareAPI } from 'redux';
import { get } from 'lodash';
import { APP_INITIALIZATION_SUCCESS } from '../actions/actionTypes/common';
import { PAGES } from '../../utils/pages';
import { APP_INIT_STATUS } from '../../utils/constants';
import { type RootState } from '../types';

export const initialDataFetcher: Middleware = (store: MiddlewareAPI<Dispatch<AnyAction>, RootState>) => {
    let firstNavAction: AnyAction | null = null;
    return (next: Dispatch<AnyAction>) => (action: AnyAction) => {
        const state = store.getState();
        const appStatus = get(state, 'common.appStatus');

        if (action.type !== PAGES.LOGIN && action.type !== PAGES.RECOVERY) {
            if (appStatus === APP_INIT_STATUS.INITIAL && get(action, 'meta.location') != null) {
                firstNavAction = action;
                return;
            }
        }
        if (action.type === APP_INITIALIZATION_SUCCESS && firstNavAction) {
            next(firstNavAction);
            firstNavAction = null;
            return next(action);
        }

        return next(action);
    };
};
